import Home from '@/v3/modules/card/views/zujuan/Home'
export default [
    {
        path: '/third/:platform',
        name: 'Home',
        component: Home
    }
]